export type DiscountTierType = 'SOLUTION_PARTNER_PLATINUM' | 'SOLUTION_PARTNER_GOLD' | 'SOLUTION_PARTNER_SILVER';

export const PARTNER_DISCOUNT_TIER_PROMOTION_ID_MAPPING = {
  SOLUTION_PARTNER_PLATINUM: 'a94fe22c-3081-4812-ad0b-25f0d067b7c5',
  SOLUTION_PARTNER_GOLD: 'b28acb17-f605-4fec-9e46-ac126c427a22',
  SOLUTION_PARTNER_SILVER: 'afc30227-ee93-4b03-a75b-383414a77b23',
};
